var _style, _mask, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstructionDoc4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 85,
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n        .instructionDoc4Fill1 { fill:#FFFDFD }\r\n        .instructionDoc4Fill2 { fill:#F9D3D3 }\r\n        .instructionDoc4Fill3 { fill:#D4A2A2 }\r\n    ")), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "instructionDoc4Mask1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-16.3918 -16.3919L132.394 -40.8222L199.919 92.8649L92.8649 199.918L-40.8222 132.394L-16.3918 -16.3919Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-16.3918 -16.3919L132.394 -40.8222L199.919 92.8649L92.8649 199.918L-40.8222 132.394L-16.3918 -16.3919Z",
    className: "instructionDoc4Fill1",
    stroke: "url(#instructionDoc4Linear1)",
    strokeWidth: 20,
    mask: "url(#instructionDoc4Mask1)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 42,
    width: 65,
    height: 85.0909,
    rx: 6,
    className: "instructionDoc4Fill2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52.9091,
    y: 102.272,
    width: 53.1818,
    height: 2.36364,
    className: "instructionDoc4Fill3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 88.3635,
    y: 49.0908,
    width: 17.7273,
    height: 17.7273,
    className: "instructionDoc4Fill3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 52.9091,
    y: 49.0908,
    width: 26,
    height: 5.90909,
    className: "instructionDoc4Fill3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 52.9091,
    y: 58.5454,
    width: 13,
    height: 2.36364,
    className: "instructionDoc4Fill3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 52.9091,
    y: 71.5454,
    width: 10.6364,
    height: 2.36364,
    className: "instructionDoc4Fill3"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 52.9091,
    y: 78.6362,
    width: 53.1818,
    height: 2.36364,
    className: "instructionDoc4Fill3"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 52.9091,
    y: 85.7271,
    width: 53.1818,
    height: 2.36364,
    className: "instructionDoc4Fill3"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 52.9091,
    y: 94,
    width: 53.1818,
    height: 2.36364,
    className: "instructionDoc4Fill3"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 84.818,
    y: 116.455,
    width: 21.2727,
    height: 2.36364,
    className: "instructionDoc4Fill3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "instructionDoc4Linear1",
    x1: 72.9134,
    y1: 73.107,
    x2: 169.046,
    y2: 252.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8F8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructionDoc4);
export default __webpack_public_path__ + "static/media/instructionDoc4.7e10954a6252b18224a665d684e8048b.svg";
export { ForwardRef as ReactComponent };